<template lang="pug">
el-dialog.modal-upload-laudos-em-lote(
    :visible.sync='show',
    :close-on-click-modal='false',
    :destroy-on-close='true',
    :before-close='fechar',
    :show-close='true',
    :close-on-press-escape='closeOnEsc',
    width='50%'
)
    template(slot='title')
        .modal-upload-laudos-em-lote__titulo {{ $t('mensagens.laudos.renovabio.modalUploadLote.tituloModal') }}

    section
        .mb-2
            span.mr-2(style='color: red') *
            span.font-weight-bold(
                v-html='$t("mensagens.laudos.renovabio.modalUploadLote.textoCorpoModal1")'
            )
        ul
            li.mb-2(
                v-html='$t("mensagens.laudos.renovabio.modalUploadLote.textoCorpoModal2")'
            )
            li.mb-2(
                v-html='$t("mensagens.laudos.renovabio.modalUploadLote.textoCorpoModal4")'
            )
            li.mb-2(
                v-html='$t("mensagens.laudos.renovabio.modalUploadLote.textoCorpoModal5")'
            )
            li.mb-2(
                v-html='$t("mensagens.laudos.renovabio.modalUploadLote.textoCorpoModal6")'
            )
            li.mb-2(
                v-html='$t("mensagens.laudos.renovabio.modalUploadLote.textoCorpoModal7")'
            )

        el-alert.mb-3.px-4(
            :title='$t("mensagens.laudos.renovabio.modalUploadLote.textoCorpoModalAlert")',
            type='warning',
            :closable='false',
            show-icon
        )

        .mb-2 {{ $t('mensagens.laudos.renovabio.modalUploadLote.textoCorpoModal3') }}
            BaseButton.ml-1(
                style='font-weight: bold',
                type='text',
                icon='el-icon-download',
                @click='downloadModeloPlanilha'
            ) {{ $t('mensagens.laudos.renovabio.modalUploadLote.baixarPlanilhaModelo') }}

        section(v-show='arquivoEscolhido.length === 0')
            el-upload.mb-2(
                action='#',
                :auto-upload='false',
                :on-change='enviarPlanilha',
                :on-exceed='onExceed',
                :file-list='fileList',
                :limit='1',
                drag,
                ref='refUploadLaudosEmLote'
            )
                i.el-icon-upload
                .el-upload__text(
                    v-html='$t("mensagens.laudos.renovabio.modalUploadLote.textoDisclaimer1")'
                )
                span.el-upload__formats {{ $t('mensagens.laudos.renovabio.modalUploadLote.textoDisclaimer2') }}

        .tabelaProcessamento(v-if='arquivoEscolhido.length > 0')
            el-table(
                height='100%',
                :data='arquivoEscolhido',
                style='width: 100%'
            )
                el-table-column(
                    prop='planilha_importada',
                    :label='$t("mensagens.laudos.renovabio.modalUploadLote.tabelaColuna1")'
                )

                el-table-column(
                    prop='status',
                    :label='$t("mensagens.laudos.renovabio.modalUploadLote.tabelaColuna2")'
                )
                    template(slot-scope='scope')
                        el-tag(:type='scope.row.status.type', size='medium')
                            el-icon.mr-2(:class='scope.row.status.icon')
                            | {{ scope.row?.status?.nome }}

                el-table-column(
                    prop='qtdeCars',
                    v-if='arquivoEscolhido[0].status.id === 3',
                    :label='$t("mensagens.laudos.renovabio.modalUploadLote.tabelaColuna4")'
                )
                    template(slot-scope='scope')
                        span(v-if='arquivoEscolhido[0].status.id === 3') {{ qtdeCars || '--' }}

                el-table-column(
                    v-if='arquivoEscolhido[0].status.id === 2',
                    prop='planilha_com_erro',
                    :label='$t("mensagens.laudos.renovabio.modalUploadLote.tabelaColuna3")'
                )
                    template(slot-scope='scope')
                        BaseButton(
                            icon='el-icon-download',
                            type='primary',
                            size='mini',
                            @click='downloadArquivoErro'
                        ) {{ $t('mensagens.laudos.renovabio.modalUploadLote.fazerDownload') }}

        section(
            v-if='arquivoEscolhido.length > 0 && arquivoEscolhido[0].status.id === 2'
        )
            .mt-3(
                v-html='$t("mensagens.laudos.renovabio.modalUploadLote.textoPlanilhaComErro")'
            )

    template(slot='footer')
        .d-flex.justify-content-between
            BaseButton(@click='fechar')
                span
                    | {{ $t('mensagens.comuns.sair') }}
            BaseButton(
                type='primary',
                :disabled='desabilitarConfirmar || (arquivoEscolhido.length > 0 && arquivoEscolhido[0].status.id === 3 && Number(qtdeCars) === 0)',
                @click='solicitarLaudosEmLote'
            )
                | {{ $t('mensagens.comuns.finalizar') }}
</template>

<script>
import LaudosService from '@/services/LaudosService';
import AuthService from '@/services/AuthService';
import * as XLSX from 'xlsx';
import { mapState, mapGetters } from 'vuex';
import { retryOperation } from '@/utils/retry-operation';
import { connect, subscribe, disconnect } from '@/utils/websocket';
import TipoLaudo from '@/constants/TipoLaudo';
import store from '@/store';
import BaseButton from '@/components/vegaComponents/BaseButton.vue';

export default {
    name: 'ModalUploadLaudosEmLote',

    components: {
        BaseButton
    },

    emits: ['atualizar'],

    props: {
        show: {
            type: Boolean,
            required: true,
            default: false
        }
    },

    data() {
        return {
            arquivoEscolhido: [],
            arquivoHash: null,
            planilhaResultados: null,
            carsNovos: [],
            decisaoUsuario: 'todos',
            desabilitarConfirmar: true,
            timeoutEvitarLogOff: null,
            status: [
                {
                    id: 1,
                    nome: this.$t('mensagens.operacao.uploadEmProcessamento'),
                    type: 'info',
                    icon: 'el-icon-loading'
                },
                {
                    id: 2,
                    nome: this.$t('mensagens.operacao.processadoComErro'),
                    type: 'danger',
                    icon: 'el-icon-warning-outline'
                },
                {
                    id: 3,
                    nome: this.$t('mensagens.operacao.processadoComSucesso'),
                    type: 'success',
                    icon: 'el-icon-circle-check'
                }
            ],
            qtdeCars: 0,
            fileList: [],
            closeOnEsc: true,
            closedModalConfirmacao: false,
            modeloPlanilha:
                'UEsDBBQABgAIAAAAIQBBN4LPbgEAAAQFAAATAAgCW0NvbnRlbnRfVHlwZXNdLnhtbCCiBAIooAACAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACsVMluwjAQvVfqP0S+Vomhh6qqCBy6HFsk6AeYeJJYJLblGSj8fSdmUVWxCMElUWzPWybzPBit2iZZQkDjbC76WU8kYAunja1y8T39SJ9FgqSsVo2zkIs1oBgN7+8G07UHTLjaYi5qIv8iJRY1tAoz58HyTulCq4g/QyW9KuaqAvnY6z3JwlkCSyl1GGI4eINSLRpK3le8vFEyM1Ykr5tzHVUulPeNKRSxULm0+h9J6srSFKBdsWgZOkMfQGmsAahtMh8MM4YJELExFPIgZ4AGLyPdusq4MgrD2nh8YOtHGLqd4662dV/8O4LRkIxVoE/Vsne5auSPC/OZc/PsNMilrYktylpl7E73Cf54GGV89W8spPMXgc/oIJ4xkPF5vYQIc4YQad0A3rrtEfQcc60C6Anx9FY3F/AX+5QOjtQ4OI+c2gCXd2EXka469QwEgQzsQ3Jo2PaMHPmr2w7dnaJBH+CW8Q4b/gIAAP//AwBQSwMEFAAGAAgAAAAhALVVMCP0AAAATAIAAAsACAJfcmVscy8ucmVscyCiBAIooAACAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACskk1PwzAMhu9I/IfI99XdkBBCS3dBSLshVH6ASdwPtY2jJBvdvyccEFQagwNHf71+/Mrb3TyN6sgh9uI0rIsSFDsjtnethpf6cXUHKiZylkZxrOHEEXbV9dX2mUdKeSh2vY8qq7iooUvJ3yNG0/FEsRDPLlcaCROlHIYWPZmBWsZNWd5i+K4B1UJT7a2GsLc3oOqTz5t/15am6Q0/iDlM7NKZFchzYmfZrnzIbCH1+RpVU2g5abBinnI6InlfZGzA80SbvxP9fC1OnMhSIjQS+DLPR8cloPV/WrQ08cudecQ3CcOryPDJgosfqN4BAAD//wMAUEsDBBQABgAIAAAAIQBQm7FypgMAAPwIAAAPAAAAeGwvd29ya2Jvb2sueG1srFVtb6M4EP5+0v0Hi+8UTIAQ1GQV3u4qtbtVNtveSZEqF5xgFXDONk2qav/7jUlI2s3plOteRGxsjx8/M/OMufy0rSv0TIVkvBkb+MI2EG1yXrBmNTa+zTMzMJBUpClIxRs6Nl6oND5Nfv3lcsPF0yPnTwgAGjk2SqXWoWXJvKQ1kRd8TRtYWXJREwVDsbLkWlBSyJJSVVeWY9u+VRPWGDuEUJyDwZdLltOE521NG7UDEbQiCujLkq1lj1bn58DVRDy1azPn9RogHlnF1EsHaqA6D69WDRfksQK3t9hDWwGPD39sQ+P0J8HSyVE1ywWXfKkuANrakT7xH9sWxu9CsD2NwXlIriXoM9M5PLAS/gdZ+Qcs/wiG7Z9GwyCtTishBO+DaN6Bm2NMLpesonc76SKyXn8mtc5UZaCKSJUWTNFibAxhyDf0OAFeiXYdtayCVWfoOp5hTQ5yvhWooEvSVmoOQu7hoTJ8f7SzBGFMK0VFQxSNeaNAh3u/flZzk0vAjksOCkcz+lfLBIXCAn2Br9CSPCSP8paoErWiGhtxuPgmwf0FrRhUHDgNcl58aWgi2DNFJrqqyYrW6DfKJZNKlyWiKOY1FTnj6HqeTBcJ3zQVh6pcvJEzOa2d/yBokut4WgdXdu8/hgw8EmEv2lslELxfJdeQuK/kGdIIYin2VX4FecKDhyYXIX54daMgjtMsMFPb9U03HqZmEAWRiYeZjQeBE9lu8B2cEX6Yc9Kqcq8QDT02XJDDydIN2fYr2A5bVhxpvNr7n6n7H5p+7bt2WN+Fd4xu5FFLeoi296wp+GZsmNgBp17eDzfd4j0rVAliHNkumOzmfqdsVQJj7A31PqgZzWxsvMZOnHnxNDLtQTCAADgjM0oS38wyL3WHTjb14kHHyHpDqbt1gVrXo6arlNuKNKwqCYYbXl/KXZyhOEJ9jLgqcJfHfmdOqhyKQ3ed4Qjbzkhb0K26lqrrQZcMGGLXng7tkWva6cAz3WDkmIE7cMzYTZzUG6ZJGnk6RfrDEf4f12dXHmH/RdIsSyLUXJD8Cb5jM7qMiARN7RwCvm/JRl4Q2QOg6GY4M108ss0o8l3TS7KBN8RJnHrZkax2f/nByyuwut2UqBYKW9d0Nw51m+1nD5PL3cQ+Ve/KL5wlOu773f9m+BW8r+iZxtndmYbx55v5zZm21+n84T4713h6EyXT8+2ns9n0z3n6R3+E9Y8BtbqE67aTqdXLZPI3AAAA//8DAFBLAwQUAAYACAAAACEAgT6Ul/MAAAC6AgAAGgAIAXhsL19yZWxzL3dvcmtib29rLnhtbC5yZWxzIKIEASigAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAArFJNS8QwEL0L/ocwd5t2FRHZdC8i7FXrDwjJtCnbJiEzfvTfGyq6XVjWSy8Db4Z5783Hdvc1DuIDE/XBK6iKEgR6E2zvOwVvzfPNAwhi7a0egkcFExLs6uur7QsOmnMTuT6SyCyeFDjm+CglGYejpiJE9LnShjRqzjB1Mmpz0B3KTVney7TkgPqEU+ytgrS3tyCaKWbl/7lD2/YGn4J5H9HzGQlJPA15ANHo1CEr+MFF9gjyvPxmTXnOa8Gj+gzlHKtLHqo1PXyGdCCHyEcffymSc+WimbtV7+F0QvvKKb/b8izL9O9m5MnH1d8AAAD//wMAUEsDBBQABgAIAAAAIQBAwpUVkQMAAFYLAAAYAAAAeGwvd29ya3NoZWV0cy9zaGVldDEueG1snJNdj6IwFIbvN9n/0PQeSxEUiThRR7Nzt5n9uq7lII2UkraOms3+9z3AjLOJycZMAhR6+j7nk/nDWdfkBaxTpskpH4WUQCNNoZp9Tn983wYpJc6LphC1aSCnF3D0YfH50/xk7MFVAJ4goXE5rbxvM8acrEALNzItNGgpjdXC46fdM9daEEUv0jWLwnDCtFANHQiZvYdhylJJeDTyqKHxA8RCLTzG7yrVujealvfgtLCHYxtIo1tE7FSt/KWHUqJl9rRvjBW7GvM+81hIcrZ4RXiP39z0+zeetJLWOFP6EZLZEPNt+jM2Y0JeSbf534XhMbPworoGvqOij4XEkysreoeNPwibXGFduWx2VEVOf2/i8WoZRjzYbqIwiNerWZBO42WQrlOeTmeTzWS5+kMX80Jhh7usiIUyp0uerfmMssW8H6CfCk7un3fixe4b1CA9oBNOSTefO2MO3cEn3Ao7KbvRbvv5/GpJAaU41v7ZnL6A2lceIQlG3bU9Ky6P4CTOG2JGUdKRpKnRPT6JVt2Pg/MizoNjVfgqpwkfJdNwzPE4kUfnjf41GPirfBBimXshrqfBPg5HcZRM0165A+e3qgvmvxSsb0/B9ZUS87sprM/lLwAAAP//AAAA//+UlesKgkAQRl9F9gHSz7Qbm9DlRcSEflW00uXtm4WYHWMXm3/mHA4j7jHrzn0/HNuhbez9+szuWwOTuVt7cXS1mZvshartNqf3sXddfxm2ppiVtWls59kdwXTL0e9HM7f5o7F5953t5Qyr8fAwGq55mNMSvEmp2YRg3qSI++hp/n8ygtmHuK/S+AhmXxn31Rofweyr4r6Fxkcw++q4b6nxEcy+Rdy30vgIZt8y7ltrfARP7YdClQLRbAzHfXSioYtLRpJoBKpIPB1OdSITqDrxdFAmSoEqFU8HZSIWqGrxdFCGL9X47aiCgSwGiQQhm6HXOfE1ldEgUSFkNtNK2Q0SIUKWM62U6eC3xTz8o3wAAAD//wAAAP//dI5NDoIwEIWv0swBpMXyZyh7F644QQ0DNGqnGcaYeHohujLhW77vveS1yU948TyFuKg7juJAHwpjamN0bkFxmOb/TChtraqurDZFZZsvJagridBjR87oB+RNHo1tSl3m+kcOaiSSPZl17fayR3kmlXxC7sMbHTSgiANG8RIoOkjEwj7I+voUBgd8Hgys4+xFfFtmROk+AAAA//8DAFBLAwQUAAYACAAAACEAbQyExmYHAAAEIQAAEwAAAHhsL3RoZW1lL3RoZW1lMS54bWzsWUuPGzcSvgfIfyD6LuvVrcfAsqGnJ/aMbXhkL3LkSJSaHnZTIKkZC4GBwDnlEiBAdrGXBfa2hyBIgARYI5f8GAM2stkfsUV2S02OqHhsjxdOMDPAjJr6qlisKn6sLl6/+SRh6JQISXnaCarXKgEi6YRPaTrvBA/Ho1IrQFLhdIoZT0knWBEZ3Lzx8UfX8Z6KSUIQyKdyD3eCWKnFXrksJzCM5TW+ICl8N+MiwQoexbw8FfgM9CasXKtUGuUE0zRAKU5A7Rhk0JSje7MZnRBUq1TrqAT/arXgxnqqIYP5UiX1wISJIz0RyeV3yE1PqhotV7LPBDrFrBOABVN+NiZPVIAYlgq+6AQV8xOUb1wv471ciKkdspbcyPzkcrnA9KRm5hTz482kYRiFje5GvwEwtY0bNoeNYWOjzwDwZAKrzmxxdTZr/TDHWqDso0f3oDmoVx28pb++ZXM30r8O3oAy/eEWfjTqgxcdvAFl+GgLH/XavYGr34AyfGML36x0B2HT0W9AMaPpyRa6EjXq/fVqN5AZZ/teeDsKR81arrxAQTZsMk1PMeOpukjeJfgxFyMAayGGFU2RWi3IDE8g1/uY0WNB0QGdx5CEC5xyCcOVWmVUqcNf/RuaTya6eI9gS1rbCFbJrSFtG5ITQReqE9wGrYEFefn8+YtnP7149u8XX3zx4tn3+dxGlSO3j9O5Lffbv77+7z8+R//58Z+/ffPXbOrzeGnjX3335auff/k99bDiwhUv//bDq59+ePn3r3799huP9q7AxzZ8TBMi0V1yhh7wBBbosZ8cizeTGMeYOhI4Bt0e1UMVO8C7K8x8uB5xXfhIAOP4gLeWjx1bj2KxVNQz8504cYCHnLMeF14H3NFzWR4eL9O5f3KxtHEPMD71zd3HqRPg4XIBtEt9Kvsxccy8z3Cq8JykRCH9HT8hxLO6Tyl1/HpIJ4JLPlPoU4p6mHpdMqbHTiIVQvs0gbisfAZCqB3fHD5CPc58qx6QUxcJ2wIzj/Fjwhw33sJLhROfyjFOmO3wA6xin5FHKzGxcUOpINJzwjgaTomUPpl7AtZrBf0OMIw/7IdslbhIoeiJT+cB5txGDvhJP8bJwmszTWMb+4k8gRTF6D5XPvghd3eIfoY44HRnuB9R4oT79UTwEMjVNqlIEP3NUnhieYtwdz+u2AwTH8t0ReKwa1dQb3b0lnMntQ8IYfgMTwlBDz/xWNDjC8fnhdG3Y2CVfeJLrNvYzVX9nBJJkKlxtinygEonZY/InO+w53B1jnhWOE2w2KX5LkTdSV045bxUeo9NTmzgXQpFIuSL1yn3JOiwknu4S+v9GDtnl36W/nxdCSd+F9ljsC8fv+m+BBnyxjJA7Bf2zRgzZ4IiYcYYCgwf3YKIE/5CRJ+rRmzplZu5m7YIAxRJTr2T0PS1xc+5sif6/5Q9/gLmEgoev+J3KXV2Ucr+uQJnF+4PWNYM8DK9T+Ak2easq6rmqqoJ/vRVza69fFXLXNUyV7WM7+3rvdQyRfkClU3R8TH9n+RC7Z8ZZexIrRg5kKYDJOHtZjqCQdOmMn3LTWtwEcPHvPHk4OYCGxkkuPoLVfFRjBfQJqqahuhc5qrnEi24hO6RGTbNV3JOt+lBLZNDPs06oNWq7nZm7pRYFeOVaDMOHSuVoRvNoqu3UW/6pHPTiV0boGXfxAhrMteIuseI5noQIvJ7RpiVXYoVbY8VLa1+Hap1FDeuANM2UYHXbwQv7Z0gCrPOMjTmoFSf6jhlTeZ1dHVwLjXSu5zJ7AyAcnudAUWk29rWncvTq8tS7QKRdoyw0s01wkrDGF6K8+y0W/GXGet2EVLHPO2K9W4ozGi23kesNaGc4waW2kzBUnTWCRr1CO5hJnjRCWbQPYaPyQJyR+o3MMzmcFEzUSLb8G/DLAsh1QDLOHO4IZ2MDRKqiECMJp1AL3+TDSw1HGJsq9aAED5Y49pAKx+acRB0N8hkNiMTZYfdGtGezh6B4TOu8H5rxN8erCX5EsJ9FE/P0DFbigcYUixqVrUDp1TCJUI18+aUwg3ZhsiK/Dt3MOW0a19RmRzKxjFbxDg/UWwyz+CGRDfmmKeND6ynfM3g0G0XHs/1AfvOp+7rj2rtOYs0izPTYRV9avrJ9P0d8pZVxSHqWJVRt3m/lgXXtddcB4nqPSVec+pe4ECwTCsmc0zTFm/TsObsfNQ17RILAssTjR1+25wRXk+87ckPcuezVh8Q6xrTJL65ZLdvvvnxYyCPAdwlLpmSJpRwly0wFH3ZzWRGG7BFnqi8RoRPaCloJ/isEnXDfi3qlyqtaFgK62Gl1Iq69VI3iurVYVStDHq1p3CwqDipRtkF/wiuM9gqv+Y341tX/cn6xubahCdlbq7wy8Zwc9VfrTlX/dtX9Wisb/IDRIGAPmvURu16u9cotevdUSkc9Fqldr/RKw0a/eZgNOhHrfboaYBODTjs1vthY9gqNar9filsVPRSWu1SM6zVumGz2xqG3ad5SQNeyKgk9wu42th4438AAAD//wMAUEsDBBQABgAIAAAAIQB5oYBspAIAAFIGAAANAAAAeGwvc3R5bGVzLnhtbKRVbWvbMBD+Pth/EPruynbjLAm2y9LUUOjGoB3sq2LLiahejCRnzsb++052Xhw6ttF+iU7n03PP3XNS0ptOCrRjxnKtMhxdhRgxVeqKq02Gvz4VwQwj66iqqNCKZXjPLL7J379LrdsL9rhlzCGAUDbDW+eaBSG23DJJ7ZVumIIvtTaSOtiaDbGNYbSy/pAUJA7DKZGUKzwgLGT5PyCSmue2CUotG+r4mgvu9j0WRrJc3G+UNnQtgGoXTWiJumhqYtSZY5Le+yKP5KXRVtfuCnCJrmtespd052ROaHlGAuTXIUUJCeOL2jvzSqQJMWzHvXw4T2utnEWlbpUDMYGob8HiWenvqvCfvHOIylP7A+2oAE+ESZ6WWmiDHEgHnes9iko2RNxSwdeG+7CaSi72gzv2jl7tQ5zk0HvvJJ7HYbFwiAtxYhV7AuDIU5DPMaMK2KCD/bRvIL2CSRtg+rh/RG8M3UdxMjpA+oR5utamgsk+9+PoylPBagdEDd9s/ep0A79r7Ryon6cVpxutqPClDCAnA8opmRCPfvq/1RfYXY1UKwvp7qsMwz3yTTiaUMjBHPCGjccfow3Yb4ZFXX2JD4gj2hekT+mR1zvDn/11FTA5Bwi0brlwXP2BMGBW3bkFoVfA+avXN+eUBTpRsZq2wj2dPmb4bH9iFW9lfIr6wnfa9RAZPtsPXqlo6nOwzj1YGC9YUWt4hn/eLT/MV3dFHMzC5SyYXLMkmCfLVZBMbperVTEP4/D21+gBeMP179+rPIWLtbACHglzKPZQ4uPZl+HRZqDfzyjQHnOfx9PwYxKFQXEdRsFkSmfBbHqdBEUSxavpZHmXFMmIe/LKZyIkUTQ8OJ58snBcMsHVUaujQmMviATbvxRBjkqQ859B/hsAAP//AwBQSwMEFAAGAAgAAAAhAB0EEEeNAgAA/QQAABQAAAB4bC9zaGFyZWRTdHJpbmdzLnhtbHxUTW/bRhC9F+h/IHhnuLM7s7sTSAr2M0hRR4btXHITbDYWYFGOSQfpv+8Q7qGIVJ0IcvfNm/feDFcffh6emh/Dy7Q/jusW3qm2Gcb748N+/LZuv9zVzrfNNO/Gh93TcRzW7d/D1H7Y/P7baprmRrDjtG4f5/n5fd9P94/DYTe9Oz4Po5z8dXw57GZ5ffnWT88vw+5hehyG+fDUa6Vsf9jtx7a5P76O87rV0Dav4/7765D+/aDazWrab1bz5uquI1DOKOosg1bRF1Wix+w8Z1OqARMUY3Ihrvp5s+oX2H+hhpTuSlCRbIxswWOwxBpYFV2xVkCpfgHKzhOwK56ClevyTDWwj+QAklLlV2gKNyfVPnYGrLfKdgFyYZ0UarRYPLB1LrNTnJAR6KTaVeg0gFIiH5AqVV2tKwUzFc9kDaWUSsw6WDjLCmxEvmZbFsuq8YTKWw/eJV9LIhIh6n+cc+BVlworF5CKY6mgK4eCxiymJpNzthdYqzHKpqidNxbBJQbLJLpDCZGi9Weh6JXCLsaCwoCsPSNKciGx+F6wUEVx7Xxebw1zkbZS9qgCGgVREFhzCaglgKAvsJqsdaYEfqFPDr3z0ryknjgZyu4ClCAv9wLVgOhQpjEqSTakkKT9eprrMhJvWkll0QqpEBNGW2XCQ81kSNxjy5dYQwAEUSq9Aaaq2PocOatqs2UDp7kurFoGcckVg0sEIUTxh8DLhljjTEZZLonprNY3aBFLLGUOgkVy2mvZTPJCLa4Fm8+HIwunOyOXDEWTrV20JlaJNOSYfDFA9kRruq59+nz9R3N9s81f7rY3Tfy0vQq3t+FXks/bq9LfhK9h29xu06fw5yVIL7+vzT8AAAD//wMAUEsDBBQABgAIAAAAIQA7bTJLwQAAAEIBAAAjAAAAeGwvd29ya3NoZWV0cy9fcmVscy9zaGVldDEueG1sLnJlbHOEj8GKwjAURfcD/kN4e5PWhQxDUzciuFXnA2L62gbbl5D3FP17sxxlwOXlcM/lNpv7PKkbZg6RLNS6AoXkYxdosPB72i2/QbE46twUCS08kGHTLr6aA05OSonHkFgVC7GFUST9GMN+xNmxjgmpkD7m2UmJeTDJ+Ysb0Kyqam3yXwe0L0617yzkfVeDOj1SWf7sjn0fPG6jv85I8s+ESTmQYD6iSDnIRe3ygGJB63f2nmt9DgSmbczL8/YJAAD//wMAUEsDBBQABgAIAAAAIQCuC/2JuwEAACwVAAAnAAAAeGwvcHJpbnRlclNldHRpbmdzL3ByaW50ZXJTZXR0aW5nczEuYmlu7JTNSuNQFMf/afyozmIsCG5mMRRXYhlL48dOS9M6lcaEphU3syg2QqAmJU2RGRlB5i3EB5nlLF36ALN2JT6AG/3f2CLOFCniRjg3nHs+7rnn5v64HAs+DhAhRI9yiBif4dD3ESR2zKiKmKhg1NAm9Km/cOb1Lxo0zOD8g5Fu0/qI/VSKej+lcy7CGLn7dUFtsE3pFEXpe47tqvvsGLO628ziEov6cmbz28npS6dNJouTSa03/FUp9Y4IDN/VOL98ySTXauyo3Dn8xglWsMFXXqHOcy4ihzLWUGAsRzGxzi/HnALjZVor9A36eeoSvQJWE+8nK9bLrlmroRn4kddTltPqepHr//BQNGBHvhfErdgPAzh2vVEvVhuoe72w009iNO2usvIohZ0wssK292j9f7PlDLBnmNbw7hez3ewnpt1QdMqdZqeN62Pr1+3014U/q2dXjNUGa0g/1VO5yl8aaOVvUfaUPwfeP2Sf6eMIXtJZmuw3HvuMgxatHo65HqHN5H8zba4FY+aWWOM7uuxcLneo81QnixmTIQSEgBAQAkJACAgBISAEhIAQEAJCQAgIgXEIPAAAAP//AwBQSwMEFAAGAAgAAAAhAHF/7CdjAQAAewIAABEACAFkb2NQcm9wcy9jb3JlLnhtbCCiBAEooAABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAISS0U7CMBiF7018h6b3o+sYxjRjRFCuIDERo/GuaX+gcW2Xtgi8l2/gi9ltgBBNvGzP+b+e86fFaKcr9AHOK2uGmPZSjMAIK5VZDfHzYprcYuQDN5JX1sAQ78HjUXl9VYiaCevg0dkaXFDgUSQZz0Q9xOsQakaIF2vQ3Peiw0RxaZ3mIR7ditRcvPMVkCxNb4iGwCUPnDTApD4R8QEpxQlZb1zVAqQgUIEGEzyhPUp+vAGc9n8OtMqZU6uwr2OnQ9xzthSdeHLvvDoZt9ttb9tvY8T8lLzOZ09t1USZZlcCcFlIwYQDHqwr70z4+jTKolnchC/ImdSsseI+zOPGlwrkeF8+VIp7NHYbY5EENImqi6Pca+4K8tsfX2qLdc+BRDEq64odlZf+5H4xxWWWZnmSZgkdLNKU5X02uHlr4lzMN9G7C30I9S8xTyhd0JwNBiylZ8QjoGxzX36X8hsAAP//AwBQSwMEFAAGAAgAAAAhADMtwHSFAQAAEwMAABAACAFkb2NQcm9wcy9hcHAueG1sIKIEASigAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAnJLBbtswDIbvA/YOhu6NnHYohkBWUaQdetiwAEl752Q6FipLgsQayZ5+tI2mTtvTbiR/4tdHUurm0Lmix5Rt8JVYLkpRoDehtn5ficfdj4vvosgEvgYXPFbiiFnc6K9f1CaFiIks5oItfK5ESxRXUmbTYgd5wbJnpQmpA+I07WVoGmvwLpiXDj3Jy7K8lngg9DXWF/FkKCbHVU//a1oHM/Dlp90xMrBWtzE6a4B4Sv3LmhRyaKi4Pxh0Ss5FxXRbNC/J0lGXSs5TtTXgcM3GugGXUcm3gnpAGJa2AZuyVj2tejQUUpHtX17bpSj+QMYBpxI9JAueGGtom5IxdjFT0hsH3roWspKsT7UxnLfOY/tNL8cGDs4bB4OJg4Vzwp0lh/l3s4FEnwAv58Ajw4R7jjg9O0cch+bH3tmvQxfBH1k4RT+tf86PcRfugPB1oedFtW0hYc03OC38VFAPvMvkBpN1C36P9WvPR2E4/9P0x/XyelFelXzZWU3Jt9+s/wEAAP//AwBQSwECLQAUAAYACAAAACEAQTeCz24BAAAEBQAAEwAAAAAAAAAAAAAAAAAAAAAAW0NvbnRlbnRfVHlwZXNdLnhtbFBLAQItABQABgAIAAAAIQC1VTAj9AAAAEwCAAALAAAAAAAAAAAAAAAAAKcDAABfcmVscy8ucmVsc1BLAQItABQABgAIAAAAIQBQm7FypgMAAPwIAAAPAAAAAAAAAAAAAAAAAMwGAAB4bC93b3JrYm9vay54bWxQSwECLQAUAAYACAAAACEAgT6Ul/MAAAC6AgAAGgAAAAAAAAAAAAAAAACfCgAAeGwvX3JlbHMvd29ya2Jvb2sueG1sLnJlbHNQSwECLQAUAAYACAAAACEAQMKVFZEDAABWCwAAGAAAAAAAAAAAAAAAAADSDAAAeGwvd29ya3NoZWV0cy9zaGVldDEueG1sUEsBAi0AFAAGAAgAAAAhAG0MhMZmBwAABCEAABMAAAAAAAAAAAAAAAAAmRAAAHhsL3RoZW1lL3RoZW1lMS54bWxQSwECLQAUAAYACAAAACEAeaGAbKQCAABSBgAADQAAAAAAAAAAAAAAAAAwGAAAeGwvc3R5bGVzLnhtbFBLAQItABQABgAIAAAAIQAdBBBHjQIAAP0EAAAUAAAAAAAAAAAAAAAAAP8aAAB4bC9zaGFyZWRTdHJpbmdzLnhtbFBLAQItABQABgAIAAAAIQA7bTJLwQAAAEIBAAAjAAAAAAAAAAAAAAAAAL4dAAB4bC93b3Jrc2hlZXRzL19yZWxzL3NoZWV0MS54bWwucmVsc1BLAQItABQABgAIAAAAIQCuC/2JuwEAACwVAAAnAAAAAAAAAAAAAAAAAMAeAAB4bC9wcmludGVyU2V0dGluZ3MvcHJpbnRlclNldHRpbmdzMS5iaW5QSwECLQAUAAYACAAAACEAcX/sJ2MBAAB7AgAAEQAAAAAAAAAAAAAAAADAIAAAZG9jUHJvcHMvY29yZS54bWxQSwECLQAUAAYACAAAACEAMy3AdIUBAAATAwAAEAAAAAAAAAAAAAAAAABaIwAAZG9jUHJvcHMvYXBwLnhtbFBLBQYAAAAADAAMACYDAAAVJgAAAAA='
        };
    },

    computed: {
        ...mapState(['usuarioLogado']),
        ...mapGetters([
            'emProcessamentoUploadLoteRenovabio',
            'emProcessamentoDownloadLoteRenovabio'
        ])
    },

    beforeDestroy() {
        if (!this.emProcessamentoUploadLoteRenovabio && !this.emProcessamentoDownloadLoteRenovabio) {
            disconnect();
        }
    },

    methods: {
        downloadModeloPlanilha() {
            const linkSource = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${this.modeloPlanilha}`;
            const link = document.createElement('a');
            const fileName = 'Modelo_xlsx_laudos_renovabio.xlsx';
            link.href = linkSource;
            link.download = fileName;
            link.click();
            link.remove();
        },

        loopingTimeout() {
            this.timeoutEvitarLogOff = setInterval(() => {
                this.buscarDadosUsuarioLogado();
            }, 120000);
        },

        async buscarDadosUsuarioLogado() {
            await AuthService.buscarDadosUsuarioLogado(false);
        },

        async verificarJaCadastrados(planilha) {
            try {
                LaudosService.verificarTipoArquivo(planilha).then(async resposta => {
                    if (resposta.data) {
                        const dadosPlanilha = await this.lerArquivoXLSX(
                            planilha
                        );
                        const response =
                            await LaudosService.verificarLaudosNovos(
                                dadosPlanilha.slice(1),
                                TipoLaudo.RENOVABIO
                            );
                        const dados = response.data;
                        this.carsNovos = dados.cars;

                        if (dados.quantidadeDuplicados > 0) {
                            this.$emit(
                                'carJaCadastradosEncontrados',
                                dados.quantidadeDuplicados
                            );
                        } else {
                            this.processarPlanilha(this.planilhaResultados);
                        }
                    } else {
                        this.$notify.error({ message: this.$t('mensagens.laudos.renovabio.modalUploadLote.planilhaForaPadrao'), duration: 10000 });
                        this.limpar();
                    }
                }).catch(erro => {
                    this.$notify.error({ message: erro.response.data.message });
                    return false;
                });
                
            } catch (error) {
                this.$notify.error({ message: error });
            }
        },

        prosseguirBaseadoNaDecisao(decisao) {
            if (decisao === 'todos') {
                this.processarPlanilha(this.planilhaResultados);
            } else if (decisao === 'novos') {
                this.processarPlanilha(
                    this.planilhaResultados,
                    this.carsNovos
                );
            } else if (decisao === 'cancelar') {
                this.$refs.refUploadLaudosEmLote.clearFiles();
            }
        },

        s2ab(s) {
            const buf = new ArrayBuffer(s.length);
            const view = new Uint8Array(buf);
            for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
            return buf;
        },

        async processarPlanilha(planilha, carsNovos) {
            try {
                let dadosPlanilha = await this.lerArquivoXLSX(planilha);

                if (carsNovos && dadosPlanilha.length > 0) {
                    const cabecalho = dadosPlanilha.slice(0, 1)[0];

                    if (carsNovos.length === 0) {
                        this.$refs.refUploadLaudosEmLote.clearFiles();
                        this.$notify.warning({
                            message: this.$t(
                                'mensagens.laudos.renovabio.naoHaNovosCarsParaProcessar'
                            )
                        });
                        return;
                    }

                    carsNovos.unshift(cabecalho);
                    const dadosNovaPlanilha = carsNovos.map(item => {
                        return [
                            item.car,
                            item.cpfCnpjProdutorBiomassa || '',
                            item.nomeRazaoSocialProdutorBiomassa || ''
                        ];
                    });

                    let novaPlanilha = XLSX.utils.book_new();
                    let novaAba = XLSX.utils.aoa_to_sheet(dadosNovaPlanilha);
                    XLSX.utils.book_append_sheet(
                        novaPlanilha,
                        novaAba,
                        'Filtrada'
                    );

                    const wbout = XLSX.write(novaPlanilha, {
                        bookType: 'xlsx',
                        type: 'binary'
                    });
                    const blob = new Blob([this.s2ab(wbout)], {
                        type: 'application/octet-stream'
                    });

                    let novoArquivo = new File(
                        [blob],
                        'PlanilhaFiltrada.xlsx',
                        {
                            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                        }
                    );

                    let planilhaCompativel = {
                        name: novoArquivo.name,
                        percentage: 0,
                        raw: novoArquivo,
                        uid: Date.now(),
                        size: novoArquivo.size,
                        status: 'ready'
                    };

                    this.planilhaResultados = planilhaCompativel;
                }

                this.arquivoEscolhido.push({
                    planilha_importada: planilha?.name,
                    status: this.status[0]
                });

                subscribe(
                    `${this.usuarioLogado.idKeyCloack}/laudo/carregamento-planilha`,
                    response => {
                        const data = JSON.parse(response);
                        if (response && data?.status === 'VALIDO') {
                            this.arquivoEscolhido[0].status = this.status[2];
                            this.desabilitarConfirmar = false;
                            this.arquivoHash = data?.hash;
                            this.qtdeCars = data?.qtdeCars;
                            clearInterval(this.timeoutEvitarLogOff);

                            if (this.closedModalConfirmacao === false) {
                                this.$notify.success({
                                    message: this.$t(
                                        'mensagens.operacao.notificacao.sucessoNoArquivo'
                                    )
                                });
                            }
                        } else {
                            this.arquivoEscolhido[0].status = this.status[1];
                            this.arquivoHash = data?.hash;
                            clearInterval(this.timeoutEvitarLogOff);

                            this.$notify.warning({
                                message: this.$t(
                                    'mensagens.operacao.notificacao.arquivoComErro'
                                )
                            });
                        }
                        disconnect();
                    }
                );

                await retryOperation(
                    LaudosService.uploadPlanilha,
                    this.planilhaResultados,
                    5000,
                    10
                );
            } catch (error) {
                this.desabilitarConfirmar = false;
                clearInterval(this.timeoutEvitarLogOff);
                this.$notify.error({
                    message: this.$t(
                        'mensagens.operacao.notificacao.uploadErro'
                    )
                });
                setTimeout(() => this.limpar(), 1000);
            }
        },

        async lerArquivoXLSX(planilha) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = async e => {
                    try {
                        const data = e.target.result;
                        const workbook = XLSX.read(data, { type: 'binary' });
                        const firstSheetName = workbook.SheetNames[0];
                        const worksheet = workbook.Sheets[firstSheetName];
                        const json = XLSX.utils.sheet_to_json(worksheet, {
                            header: 1
                        });

                        const cabecalho = {
                            car: json[0][0],
                            cpfCnpjProdutorBiomassa: json[0][1],
                            nomeRazaoSocialProdutorBiomassa: json[0][2]
                        };
                        let dadosPlanilha = json
                            .map(row => {
                                return {
                                    car: row[0],
                                    cpfCnpjProdutorBiomassa: row[1],
                                    nomeRazaoSocialProdutorBiomassa: row[2]
                                };
                            })
                            .slice(1);
                        dadosPlanilha.unshift(cabecalho);
                        resolve(dadosPlanilha);
                    } catch (error) {
                        reject(error);
                    }
                };
                reader.onerror = error => {
                    reject(error);
                };
                reader.readAsBinaryString(planilha.raw);
            });
        },

        async enviarPlanilha(planilha) {
            this.planilhaResultados = planilha;
            if (this.arquivoEscolhido.length > 0) {
                this.$notify.warning({
                    message: this.$t(
                        'mensagens.operacao.notificacao.enviarPlanilha'
                    )
                });
                this.$refs.refUploadLaudosEmLote.clearFiles();
                return;
            }

            if (planilha.size > 15000000) {
                this.$notify.warning({
                    message: this.$t(
                        'mensagens.operacao.notificacao.ultrapassa15MB'
                    )
                });
                this.$refs.refUploadLaudosEmLote.clearFiles();
                return false;
            }

            let extension = planilha.name.split('.').pop().toLowerCase();
            if (extension !== 'xlsx' && extension !== 'xls') {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.operacao.notificacao.tipoNaoSuportado'
                    )
                });
                this.$refs.refUploadLaudosEmLote.clearFiles();
                return false;
            }

            try {
                await connect();
            } catch {
                this.$notify.error({
                    message: this.$t('mensagens.operacao.notificacao.apiOff')
                });
                return;
            }

            if (this.usuarioLogado) {
                this.loopingTimeout();

                await this.verificarJaCadastrados(this.planilhaResultados);
                
            } else {
                this.$notify.error({
                    message: this.$t(
                        'mensagens.diagnosticoSocioambiental.erro.usuarioDeslogado'
                    )
                });
                clearInterval(this.timeoutEvitarLogOff);
                disconnect();
                setTimeout(() => this.limpar(), 100);
            }
        },

        async downloadArquivoErro() {
            await LaudosService.downloadPlanilhaErro(this.arquivoHash)
                .then(() => {
                    this.$notify.success({
                        message: this.$t(
                            'mensagens.operacao.notificacao.downloadRealizado'
                        )
                    });
                })
                .catch(() =>
                    this.$notify.error({
                        message: this.$t(
                            'mensagens.operacao.notificacao.downloadErro'
                        )
                    })
                );
        },

        onExceed() {
            this.$notify.warning({
                message: this.$t(
                    'mensagens.menuMapa.planilha.observacoes.erro.3'
                ),
                position: 'top-left'
            });
        },

        async solicitarLaudosEmLote() {
            if (this.emProcessamentoUploadLoteRenovabio || this.emProcessamentoDownloadLoteRenovabio) {
                this.$notify.warning({
                    message: this.$t(
                        'mensagens.laudos.renovabio.laudoEmLoteEmProcessamentoAsync'
                    )
                });
                return;
            }
            store.dispatch('setEmProcessamentoUploadLoteRenovabio', true);
            store.dispatch('setHashPlanilhaRenovabio', this.arquivoHash);

            this.limpar();
            this.$emit('fechar');
        },

        limpar() {
            this.arquivoEscolhido = [];
            this.arquivoHash = null;
            this.closedModalConfirmacao = false;
            this.desabilitarConfirmar = true;
            this.$refs.refUploadLaudosEmLote.clearFiles();
        },

        fechar() {
            if (
                (this.arquivoEscolhido.length > 0 &&
                    this.arquivoEscolhido[0].status.id === 3) ||
                (this.arquivoEscolhido.length > 0 &&
                    this.arquivoEscolhido[0].status.id === 1)
            ) {
                this.fecharUploadAndamento();
            } else {
                this.$emit('fechar');
                setTimeout(() => this.limpar(), 1000);
            }
        },

        async fecharUploadAndamento() {
            await this.$messageBox
                .confirm(
                    this.$t(
                        'mensagens.laudos.renovabio.modalUploadLote.desejaCancelarUploadLaudo'
                    ),
                    this.$t(
                        'mensagens.laudos.renovabio.modalUploadLote.tituloModalCancelarAndamentoLaudos'
                    ),
                    {
                        dangerouslyUseHTMLString: true,
                        confirmButtonText: this.$t(
                            'mensagens.comuns.continuarSolicitacao'
                        ),
                        cancelButtonText: this.$t('mensagens.comuns.sair')
                    }
                )
                .then(() => {})
                .catch(() => {
                    this.closedModalConfirmacao = true;
                    this.$emit('fechar');
                    setTimeout(() => this.limpar(), 1000);
                });
        }
    }
};
</script>

<style lang="scss">
.modal-upload-laudos-em-lote {
    .modal-upload-laudos-em-lote__titulo {
        font-weight: bold;
        color: #00413c;
        font-size: 18px;
    }

    .el-dialog__body {
        padding: 20px !important;
        word-break: keep-all;
        word-wrap: break-word;

        ul {
            padding-left: 25px;
        }

        .el-alert__title {
            font-size: 14px !important;
            font-weight: 500;
            line-height: 20px;
            letter-spacing: 0em;
            text-align: left;
            color: #3b3b3b;
        }
    }

    .el-dialog__header {
        padding-bottom: 20px !important;
        background: #e9e9e9;
    }

    .el-dialog__footer {
        padding-top: 20px !important;
        border-top: 1px solid #e9e9e9;
    }

    .el-dialog {
        background: white !important;
    }

    .el-upload__text {
        font-size: 14px;
        font-weight: 400;
        line-height: 17px;
        letter-spacing: 0em;
        margin-bottom: 8px;

        em {
            color: #276fda !important;
        }
    }

    .el-upload__formats {
        font-size: 12px;
        font-weight: 400;
        line-height: 15px;
        letter-spacing: 0em;
    }

    .el-upload-dragger {
        width: 100%;
        height: 190px !important;
    }
    .el-dialog__footer > div > button.el-button.el-button--default {
        border: 1px solid var(--primary);
    }
}
.el-message-box__btns
    > button.el-button.el-button--default.el-button--small.el-button--primary {
    background-color: var(--primary);
    border-color: var(--primary);
    color: var(--white);
}
.el-message-box__btns
    > button.el-button.el-button--default.el-button--small.el-button--primary:hover {
    background-color: var(--secondary);
    border-color: var(--secondary);
    color: var(--color-button-hover);
    outline: 0px auto var(--secondary);
}
.el-message-box__wrapper > div > div.el-message-box__btns {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}
.el-message-box__btns > button:nth-child(1) {
    border: 1px solid var(--primary);
}
.el-message-box__btns > button {
    width: auto !important;
}
.tabelaProcessamento {
    height: 200px;
}
</style>
